import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Emily Carter",
        title: "Chief AI Architect",
        biography: "Emily Carter is an accomplished Chief AI Architect with a deep passion for artificial intelligence and its applications in business. With expertise in AI development, machine learning, and strategic implementation, she drives innovation and efficiency. Her visionary approach and problem-solving skills make her a leader in the AI industry.",
        contacts: {
            phone: "222-333-4455",
            email: "emily.carter@example.com",
            website: "www.emilycarter.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Led AI-driven projects to optimize business operations",
            "Expert in machine learning algorithms and model deployment",
            "Developed scalable AI solutions for enterprise applications",
            "Proven ability to integrate AI with cloud computing platforms",
            "Passionate about advancing AI ethics and responsible AI"
        ],
        skills: [
            { id: 1, title: "AI Development", progress: 95 },
            { id: 2, title: "Machine Learning", progress: 90 },
            { id: 3, title: "Data Science", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Michael Lee",
        title: "Lead Data Scientist",
        biography: "Michael Lee is a highly skilled Lead Data Scientist with a strong background in data analytics, machine learning, and big data technologies. He specializes in transforming raw data into actionable insights, driving business growth and efficiency. His analytical expertise and problem-solving skills make him an invaluable asset in the data science field.",
        contacts: {
            phone: "333-444-5566",
            email: "michael.lee@example.com",
            website: "www.michaellee.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Developed predictive models to optimize business strategies",
            "Expert in statistical analysis and data visualization",
            "Implemented machine learning solutions for data-driven decision-making",
            "Specialized in big data processing and cloud computing",
            "Passionate about AI ethics and responsible data usage"
        ],
        skills: [
            { id: 1, title: "Machine Learning", progress: 95 },
            { id: 2, title: "Data Analytics", progress: 90 },
            { id: 3, title: "Big Data Processing", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Sophia Brown",
        title: "UX/UI Specialist",
        biography: "Sophia Brown is a highly creative UX/UI Specialist with expertise in designing user-friendly and visually appealing digital experiences. She focuses on enhancing usability, accessibility, and aesthetics to ensure seamless interactions. Her passion for user-centered design and attention to detail make her an essential asset in product development.",
        contacts: {
            phone: "444-555-6677",
            email: "sophia.brown@example.com",
            website: "www.sophiabrown.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Designed intuitive user interfaces for web and mobile applications",
            "Expert in wireframing, prototyping, and usability testing",
            "Enhanced user engagement through interactive design solutions",
            "Collaborated with developers to ensure seamless implementation",
            "Passionate about accessibility and inclusive design"
        ],
        skills: [
            { id: 1, title: "User Experience (UX)", progress: 95 },
            { id: 2, title: "User Interface (UI)", progress: 90 },
            { id: 3, title: "Prototyping", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Liam Anderson",
        title: "Cloud Engineer",
        biography: "Liam Anderson is a highly skilled Cloud Engineer with extensive experience in designing, deploying, and managing cloud-based infrastructures. He specializes in optimizing performance, ensuring security, and implementing scalable solutions. His expertise in cloud computing makes him a valuable asset in modern IT environments.",
        contacts: {
            phone: "555-666-7788",
            email: "liam.anderson@example.com",
            website: "www.liamanderson.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Designed and implemented scalable cloud architectures",
            "Expert in AWS, Azure, and Google Cloud Platform",
            "Ensured high availability and disaster recovery strategies",
            "Optimized cloud performance and cost management",
            "Secured cloud environments with best practices"
        ],
        skills: [
            { id: 1, title: "Cloud Architecture", progress: 95 },
            { id: 2, title: "Security & Compliance", progress: 90 },
            { id: 3, title: "Performance Optimization", progress: 85 }
        ]
    }

];

export default team;